export default "__VITE_ASSET__D$6wHjeD__"